import { Api } from "../api/api";
import { Api4Asp } from "../api/api4asp";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";

@Injectable()
export class ClientLogProvider {
  private url: string = "log";

  constructor(public api: Api, public api4asp: Api4Asp) {}

  webTrackTokenClick(token: any): Observable<any> {
    return this.api4asp.post("web_track_token_clicks", {
      token: token,
      click_time: new Date()
    });
  }

  post(data: any): Observable<any> {
    return this.api.post(this.url + "/client_error_log", { error: data });
  }
}



// WEBPACK FOOTER //
// ./src/providers/client-log/client-log.ts